import React, { useEffect, useState } from "react";

import {
	FrontendCompanySampleMatrix,
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";

import { Card, Divider } from "@mui/material";
import { NeutralColor, SecondaryColor } from "node-library/dist/colors";

import { FileIcon, FolderIcon } from "../../../common-components/svgIcons";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";

import { getTestCategoryMatrixMap } from "../../../helpers/testCategoryHelper";
import SpecificationFolderRow from "./modal/SpecificationFolderRow";
import SpecificationFilesAndFoldersSection from "./subComponents/specificationFilesAndFoldersSection";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo;
	orgDetailsSelectedCategory: FrontendCompanyTestCategory;

	organizationId: string;
	orgSpecifications: Array<FrontendSampleSpecification>;
	setOrgSpecifications: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecification>>
	>;
	specDirectories: Array<FrontendSampleSpecificationDirectory>;
	setSpecDirectories: React.Dispatch<
		React.SetStateAction<Array<FrontendSampleSpecificationDirectory>>
	>;
}

export default function OrgSpecificationsSection(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const {
		company,
		setCompany,
		user,
		orgDetailsSelectedCategory,
		organizationId,
		orgSpecifications,
		setOrgSpecifications,
		specDirectories,
		setSpecDirectories,
	} = props;
	const categoryMatrixMap: Map<
		string,
		Array<FrontendCompanySampleMatrix>
	> = getTestCategoryMatrixMap(props.orgDetailsSelectedCategory);

	const [matrixId, setMatrixId] = useState<string>();

	const selectedMatrix: FrontendCompanySampleMatrix | undefined = matrixId
		? props.orgDetailsSelectedCategory.sampleMatrices.find((matrix) => {
				return matrix.matrixId == matrixId;
			})
		: undefined;

	const [currentFolder, setCurrentFolder] = useState<
		FrontendSampleSpecificationDirectory | undefined
	>();

	useEffect(() => {
		setMatrixId("");
		setCurrentFolder(undefined);
	}, [props.orgDetailsSelectedCategory]);

	const currentFolderContents: React.ReactNode = selectedMatrix ? (
		<SpecificationFilesAndFoldersSection
			company={company}
			setCompany={setCompany}
			user={user}
			orgDetailsSelectedCategory={orgDetailsSelectedCategory}
			organizationId={organizationId}
			orgSpecifications={orgSpecifications}
			setOrgSpecifications={setOrgSpecifications}
			specDirectories={specDirectories}
			setSpecDirectories={setSpecDirectories}
			selectedMatrix={selectedMatrix}
			currentFolder={currentFolder}
			setCurrentFolder={setCurrentFolder}
		></SpecificationFilesAndFoldersSection>
	) : (
		<></>
	);
	function onMatrixFolderClick(subMatrixValue: FrontendCompanySampleMatrix) {
		setMatrixId(subMatrixValue.matrixId);
		setCurrentFolder(undefined);
	}

	const specificationInformation: React.ReactNode = (
		<div>
			<div>
				<div className="profile-icon-header-row typography-heading-03">
					<FileIcon></FileIcon>
					{translation("FilesAndSpecifications")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("FilesAndSpecificationsDescription")}
				</div>
			</div>

			<div className="profile-specification-folder-and-files-container">
				<div className={matrixId ? `profile-specification-not-selected` : ``}>
					<div
						className="typography-body-02 typography-bold"
						style={{ margin: "10px 0px" }}
					>
						{translation("MatrixAndSubMatrixFolders")}
					</div>

					<div id="profile-folder-selection-container">
						{Array.from(categoryMatrixMap.entries()).map(([key, value]) => {
							const children: Array<React.ReactNode> = value.map(
								(subMatrixValue: FrontendCompanySampleMatrix) => {
									return (
										<SpecificationFolderRow
											key={`sub-folder-${subMatrixValue.subMatrix}`}
											label={subMatrixValue.subMatrix}
											icon={
												<FolderIcon
													strokeColor={SecondaryColor.SECONDARY_300}
													fillColor={SecondaryColor.SECONDARY_LV10}
												/>
											}
											selected={matrixId == subMatrixValue.matrixId}
											onRowClick={() => {
												onMatrixFolderClick(subMatrixValue);
											}}
										/>
									);
								},
							);
							return (
								<SpecificationFolderRow
									key={`folder-${key}`}
									label={key}
									selected={false}
									icon={
										<FolderIcon
											strokeColor={SecondaryColor.SECONDARY_300}
											fillColor={SecondaryColor.SECONDARY_LV10}
										/>
									}
								>
									{children}
								</SpecificationFolderRow>
							);
						})}
					</div>
				</div>
				<Divider
					className="profile-specification-folder-container-divider"
					orientation="vertical"
					flexItem
				></Divider>

				{currentFolderContents}
			</div>
		</div>
	);

	// const uploadModal: React.ReactNode =

	return (
		<>
			<Card className="common-card card-normal-padding">
				{specificationInformation}
			</Card>
			{/* <DeleteSpecificationConfirmModal
				open={deleteSpecModalOpen}
				setOpen={setDeleteSpecModalOpen}
				proceedAction={proceedAction}
			></DeleteSpecificationConfirmModal>
			{matrix && matrixId && selectedMatrix && (
				<>
					<UploadSpecificationModal
						organizationId={props.organizationId}
						open={uploadSpecModalOpen}
						setOpen={setUploadSpecModalOpen}
						selectedMatrix={selectedMatrix as FrontendCompanySampleMatrix}
						currentFolderSpecifications={currentFolderSpecs}
						setFolderSpecifications={props.setOrgSpecifications}
						setSelectedSpecificationId={(id) => {}}
						testCategoryId={props.orgDetailsSelectedCategory.testCategoryId}
					></UploadSpecificationModal>
					<CreateSpecFolderModal
						open={createFolderModalOpen}
						setOpen={setCreateFolderModalOpen}
						existingFolder={undefined}
						testCategoryId={props.orgDetailsSelectedCategory.testCategoryId}
						selectedMatrix={selectedMatrix}
						parentFolder={currentFolder}
						setSpecDirectories={setSpecDirectories}
					/>
				</>
			)} */}
		</>
	);
}
